import(/* webpackMode: "eager", webpackExports: ["GalleryCategoryPageClient"] */ "/app/app/[locale]/(site)/gallery/_components/gallery-category-page-client.tsx");
